import { Dropdown, Modal, Popover, Tab, Tooltip } from "bootstrap"

function initBootstrapWidgets(root = document) {
  root.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    Dropdown.getOrCreateInstance(el)
  })
  root.querySelectorAll('[data-bs-toggle="modal"]').forEach((el) => {
    Modal.getOrCreateInstance(el)
  })
  root.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    Popover.getOrCreateInstance(el)
  })
  root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    Tooltip.getOrCreateInstance(el)
  })
  root.querySelectorAll('[data-bs-toggle="tab"]').forEach((el) => {
    Tab.getOrCreateInstance(el)
  })
}

function disposeBootstrapWidgets(root = document) {
  root.querySelectorAll(".dropdown-menu.show").forEach((menu) => menu.classList.remove("show"))
  root.querySelectorAll(".dropdown.show").forEach((dropdown) => dropdown.classList.remove("show"))

  root.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    Dropdown.getInstance(el)?.dispose()
  })
  root.querySelectorAll('[data-bs-toggle="modal"]').forEach((el) => {
    Modal.getInstance(el)?.dispose()
  })
  root.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    Popover.getInstance(el)?.dispose()
  })
  root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    Tooltip.getInstance(el)?.dispose()
  })
  root.querySelectorAll('[data-bs-toggle="tab"]').forEach((el) => {
    Tab.getInstance(el)?.dispose()
  })
}

document.addEventListener("turbo:load", () => initBootstrapWidgets(document))
document.addEventListener("turbo:before-cache", () => disposeBootstrapWidgets(document))
